"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Collection = _interopRequireDefault(require("../../core/Collection"));
var _utils = require("../../utils");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
class DataSourceStore extends _Collection.default {
  constructor() {
    super(...arguments);
    this._order = new Map();
    this._mapping = new Map();
  }
  get mapping() {
    return this._mapping;
  }
  get order() {
    return this._order;
  }
  add(key, source, order) {
    super.add(key, source);
    if ((0, _utils.isset)(order)) {
      this._order.set(key, order);
    }
  }
  get(key) {
    let source = super.get(key);
    if (!(0, _utils.isset)(source)) {
      const mapped = this.mapping.get(key);
      if (mapped) {
        source = super.get(mapped);
      }
    }
    return source;
  }
}
var _default = exports.default = DataSourceStore;
module.exports = exports.default;